module.exports = __webpack_public_path__ + "static/media/component1.06774e01.png";